import React from 'react';

const SearchResults = ({ results, query, onResultClick }) => {
  if (query && results.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500 text-sm">
        Aucun résultat trouvé
      </div>
    );
  }

  if (results.length === 0) {
    return null;
  }

  return (
    <div className="max-h-96 overflow-y-auto">
      {results.map((result) => (
        <button
          key={`${result.type}-${result.id || result.title}`}
          onClick={() => onResultClick(result)}
          className="w-full text-left p-3 hover:bg-gray-50 border-b border-gray-100 last:border-0 transition-colors"
        >
          <div className="font-medium text-navy-900 text-sm mb-1">
            {result.title}
          </div>
          <div className="text-xs text-gray-600 line-clamp-2">
            {result.description}
          </div>
          <div className="text-xs text-navy-600 mt-1 capitalize">
            {result.type}
          </div>
        </button>
      ))}
    </div>
  );
};

export default SearchResults;